import LandingReveal from '@/modules/Pages/shared/LandingReveal';

type EarlyAccessSectionProps = {
  onApplyClick: () => void;
};

export default function EarlyAccessSection({ onApplyClick }: EarlyAccessSectionProps) {
  return (
    <section id="early-access" className="py-24 px-6 border-t border-light scroll-mt-24">
      <div className="max-w-3xl mx-auto text-center">
        <LandingReveal>
          <p className="landing-section-label mb-4">Early access</p>
          <h2 className="landing-headline text-3xl md:text-4xl font-bold leading-tight mb-6">
            Protect more recurring revenue with the CS capacity you already have.
          </h2>
          <p className="landing-prose mb-10">
            Give your team a better way to find the customers at risk, understand why, and know what action to take.
          </p>
          <button
            type="button"
            onClick={onApplyClick}
            className="inline-flex px-8 py-4 rounded-lg font-semibold transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]"
            style={{
              backgroundColor: '#fafafa',
              color: '#0e1c2a',
              boxShadow: '0 8px 32px rgba(250, 250, 250, 0.1)',
            }}
          >
            Join the waitlist
          </button>
        </LandingReveal>
      </div>
    </section>
  );
}
